<script setup lang="ts"></script>

<template>
  <div class="block block">
    <h2 class=“section__title”>Bedankt voor jouw boeking</h2>
    <p>Bedankt voor jouw boeking, je ontvangt een bevestiging per e-mail</p>
  </div>
</template>

<style scoped></style>
